"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var GoldIcon_1 = __importDefault(require("./GoldIcon"));
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        root: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        snackbarMessage: {
            width: '100%',
        },
        title: {
            color: '#C8E6C9',
            width: '100%',
            fontSize: '12px',
            lineHeight: 1,
        },
    });
});
var AchievementSnackbar = function (_a) {
    var message = _a.message, other = __rest(_a, ["message"]);
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Snackbar, __assign({ autoHideDuration: 3000, anchorOrigin: { vertical: 'top', horizontal: 'right' } }, other),
        react_1.default.createElement(lab_1.Alert, { icon: false, elevation: 6, variant: "filled", severity: "success", style: { alignItems: 'center', display: 'flex', minWidth: 300 }, classes: {
                root: classes.root,
                message: classes.snackbarMessage,
            } },
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(core_1.Typography, { variant: "overline", className: classes.title }, "Achievement unlocked:"),
                    react_1.default.createElement(core_1.Typography, null, message)),
                react_1.default.createElement("div", { style: {
                        fontWeight: 'bold',
                        fontSize: '18px',
                        marginLeft: 32,
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    "+3",
                    react_1.default.createElement(GoldIcon_1.default, { active: true, style: { height: 16, marginLeft: 6 } }))))));
};
exports.default = AchievementSnackbar;
//# sourceMappingURL=AchievementSnackbar.js.map